import {
    GroupsByCategories,
    GroupWithCategoryName
} from 'components/context/types';
import { groupBy } from 'lodash';
import { NO_CATEGORY_ID } from 'components/pages/grouplistpage/GroupListPage';

export function categorizeGroups(
    groupsWithCategoryNames: GroupWithCategoryName[]
): GroupsByCategories[] {
    const groupedByCategoryId = groupBy(
        groupsWithCategoryNames,
        group => group.categoryId
    );

    return Object.keys(groupedByCategoryId).map(categoryId => {
        const groups = groupedByCategoryId[categoryId];

        if (categoryId === 'null') {
            return {
                categoryName: '',
                categoryId: NO_CATEGORY_ID,
                groups
            };
        } else {
            return {
                categoryName: groups[0].categoryName,
                categoryId,
                groups
            };
        }
    });
}
